'use strict';

var React = require('react');

var SvgTextAlignLeftIcon = function SvgTextAlignLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5h-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.75a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5h-12.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8Z"
  }));
};
SvgTextAlignLeftIcon.displayName = "TextAlignLeftIcon";

exports.SvgTextAlignLeftIcon = SvgTextAlignLeftIcon;
